var exports = {
  "iU": "x61f99309--6a6ffd--message",
  "Is": "x61f99309--6a6ffd--message__inner",
  "uz": "x61f99309--6a6ffd--message__error-sign",
  "io": "x61f99309--6a6ffd--message__error-text",
};

module.exports = exports;
